import React from 'react'
import { QuickSortCallEnvironment } from '../statepattern/stack/QuickSortCallEnvironment'

interface AlgoStackProps {
  AlgoStack: Array<any> | undefined
}

export function AlgoStackComponent ({
  AlgoStack
} : AlgoStackProps) {
  return (
    <div>
      <h1>AlgoStack</h1>
      {AlgoStack !== undefined && 
        AlgoStack.map((sel, i) => {
          
          if ((sel as QuickSortCallEnvironment).CallerStep !== undefined) {
            return(
              <p key={i}>CallEnv: {sel.CallerStep}</p>
            )
          }
          
          return (
            <p key={i}>{sel}</p>
          )
        })
      }
    </div>
  )
}
